import React from 'react';

const MessageLoader = () => {
  return (
    <div className='button is-loading is-light w-15 h-15 p-2 rounded-full mx-auto block'>
      
    </div>
  );
};

export default MessageLoader;